import React, { useState } from "react";
import cx from "clsx";
import { Transition } from "react-transition-group";

import Logo from "@/components/shared/logo";
import MobileLogoImg from "@/images/shared/elco-metallic.png";
import NavbarButton from "@/components/shared/navbarButton";
import { MENU_ITEMS } from "./constants";

import globalStyles from "@/styles/global.module.scss";
import navStyles from "./navbar.module.scss";
import styles from "./mobile-navbar.module.scss";

const MobileNavbar = props => {
  const [itemHovered, setItemHovered] = useState(null);
  const handleButtonHover = itemHovered => () => setItemHovered(itemHovered);

  const {
    location,
    isOpen,
    windowHeight,
    onNavLinkClick,
    onNavButtonClick
  } = props;

  return (
    <>
      <NavbarButton isOpen={isOpen} onClick={onNavButtonClick} />
      <div className={styles.topBar}>
        <Logo src={MobileLogoImg} className={styles.logo} isDesktop={false} />
      </div>
      <Transition enter exit in={isOpen} timeout={25}>
        {state => {
          return (
            <div
              className={cx(
                navStyles.container,
                navStyles.mobile,
                navStyles.mobileOpenAnimation,
                navStyles[state],
                isOpen && navStyles.isOpen
              )}
              style={{ height: windowHeight }}
            >
              <div className={navStyles.buttons}>
                {MENU_ITEMS.map((item, index) => {
                  const { icon: Icon } = item;

                  return (
                    <button
                      key={`nav-${item.label}`}
                      className={cx(globalStyles.buttonReset, navStyles.button)}
                      onMouseEnter={handleButtonHover(index)}
                      onMouseLeave={handleButtonHover(null)}
                      onClick={onNavLinkClick(item)}
                    >
                      <div
                        className={cx(
                          navStyles.buttonInner,
                          navStyles.hoverActive,
                          itemHovered === index && navStyles.hovered,
                          location &&
                            item.link === location.pathname &&
                            navStyles.active
                        )}
                        style={item.containerStyle}
                      >
                        <div className={navStyles.labelContainer}>
                          {item.label}
                        </div>
                        <div className={navStyles.iconContainer}>
                          {Icon ? (
                            <Icon
                              className={navStyles.buttonIcon}
                              style={item.iconStyle}
                              alt={item.label}
                            />
                          ) : null}
                        </div>
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>
          );
        }}
      </Transition>
    </>
  );
};

export default MobileNavbar;
